<template>
    <main>
       <div class="container-fluid">
            <div class="row">
               <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                      <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Application</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-filter">
                            <input type="search" value="" placeholder="Searching..." class="form-control" v-on:click="openAction">
                            <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod" @openAction="openAction"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
        <CustomList v-else ref="loadCustom"></CustomList>

    </main>
</template>

<script>
import { ref } from "vue";
import breadcrumbs from "@/views/modules/Applications/MenuList.vue";
import lang from "@/views/modules/Applications/language/en";
import GenericList from "@/components/layout/shared/generic/ListView.vue";
import CustomList from "@/views/modules/Applications/ListView.vue";
import CustomSearch from "@/views/modules/Applications/SearchView.vue";
export default {
name: "list-Intent-To-Submit",
components: {
    breadcrumbs,
    GenericList,
    CustomList,
    CustomSearch,
    },
    data(){
        return{
            generic: false,
            isActive:false,
            metaList:[
                {
                    label: lang.LBL_TAX_NAME,
                    link:false,
                    moduleName:'Opportunitys',/// moduleName is required
                    routePath:'opportunitys'/// routePath is required at start of object
                },
                {
                    label: lang.LBL_TAX_PERCENTAGE,
                    link:true,
                    routePath:'Opportunitys'/// routePath is required at start of object
                },
                {
                    label: lang.LBL_DESCRIPTION,
                    link:false,
                    routePath:''
                },
                {
                    label: lang.LBL_STATUS,
                    link:false,
                    routePath:''
                },
            ],
            columns: ['name', 'tax', 'description', 'status'],

        }
    },
    mounted() {
        this.childMethod();
    },
    methods:{
        childMethod(search=''){
            if(this.generic == true){
                this.$refs.loadGeneric.loadGenericView(this.metaList,this.columns,search);
            }else{
                if(search!=''){
                    this.$refs.loadCustom.getProducts(search);
                }
            }
        },
        openAction() {
            this.isActive = !this.isActive;
        },
    }
}

</script>



